import React, { useMemo } from "react";
import Switch from "react-switch";
import Badge from "../../../../../../../Utils/Badge/Badge";
import {
    RenderKilogramo,
    RenderNumber,
} from "../../../../../../../Utils/renderField/renderReadField";
import { agruparPalletsPorProducto } from "../../../../../../ProduccionV2/helpers/groupPallets";
import { NumeroPallet } from "../../../../../../ProduccionV2/components/NumeroPallet/NumeroPallet";
import NullableValue from "../../../../../../../Utils/renderField/nullableValue";

export const PalletsTable = (props) => {
    const {
        pallets = [],
        ActualizarRecepcionPallet,
        ToggleRecibidos,
        modoLectura,
        headerText = "Pallets formados",
    } = props;

    const todosLosPalletsRecibidos = pallets.every(function (pallet) {
        return pallet.recibido_bodega;
    });

    const palletsAgrupados = useMemo(
        function () {
            return agruparPalletsPorProducto(pallets);
        },
        [pallets],
    );

    return (
        <React.Fragment>
            <h5>{headerText}</h5>

            <div className="new-table-wrapper recepcion-ingreso__table-wrapper mb-4">
                <table>
                    <thead>
                        <tr>
                            <th>
                                {modoLectura ? (
                                    <span className="text-center">
                                        Recibido
                                    </span>
                                ) : (
                                    <div className="d-flex gap-1rem justify-content-center">
                                        <input
                                            type="checkbox"
                                            className="checkbox"
                                            checked={todosLosPalletsRecibidos}
                                            onChange={function (e) {
                                                ToggleRecibidos(
                                                    e.target.checked,
                                                );
                                            }}
                                        />

                                        <span>Recibir</span>
                                    </div>
                                )}
                            </th>

                            <th>Pallet</th>
                            <th>EVS</th>
                            <th>Cant. pacas</th>
                            <th>Pacas turno actual</th>
                            <th>Pacas turno anterior</th>
                            <th>Pacas en reclasificación</th>
                            <th>Producto conforme</th>
                            <th>Tarjeta roja</th>
                            <th>Kg hule seco</th>
                        </tr>
                    </thead>

                    <tbody>
                        {pallets.length === 0 && (
                            <tr>
                                <td className="text-center" colSpan={10}>
                                    No se han agregado pallets.
                                </td>
                            </tr>
                        )}

                        {palletsAgrupados.map(function (productoData) {
                            return (
                                <React.Fragment key={productoData.id}>
                                    {/* Encabezado producto */}
                                    <tr className="recepcion-ingreso__producto-row">
                                        <td colSpan={10}>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    justifyContent:
                                                        "space-between",
                                                }}
                                            >
                                                <span>
                                                    {productoData.padreNombre
                                                        ? `${productoData.padreNombre} - ${productoData.nombre}`
                                                        : productoData.nombre}
                                                </span>

                                                <span>
                                                    Sub-total:{" "}
                                                    <RenderKilogramo
                                                        value={
                                                            productoData.subtotalKg
                                                        }
                                                        decimalScale={2}
                                                    />
                                                </span>
                                            </div>
                                        </td>
                                    </tr>

                                    {/* Detalle */}
                                    {productoData.pallets.map(function (item) {
                                        return (
                                            <tr key={item.id}>
                                                {/* La celda completa cambia el estado con un toque; el switch solo lo muestra, porque su arrastre cancela los toques con un leve movimiento */}
                                                <td
                                                    className={
                                                        modoLectura
                                                            ? "text-center"
                                                            : "text-center recepcion-ingreso__celda-recibir"
                                                    }
                                                    onClick={
                                                        modoLectura
                                                            ? undefined
                                                            : function () {
                                                                  ActualizarRecepcionPallet(
                                                                      item.id,
                                                                      !item.recibido_bodega,
                                                                  );
                                                              }
                                                    }
                                                >
                                                    {modoLectura ? (
                                                        <Badge
                                                            text={
                                                                item.recibido_bodega
                                                                    ? "Sí"
                                                                    : "No"
                                                            }
                                                            variant={
                                                                item.recibido_bodega
                                                                    ? "success"
                                                                    : "danger"
                                                            }
                                                        />
                                                    ) : (
                                                        <Switch
                                                            className="recepcion-ingreso__switch-recibir"
                                                            height={18}
                                                            width={36}
                                                            checked={
                                                                !!item.recibido_bodega
                                                            }
                                                            onChange={function (
                                                                checked,
                                                            ) {
                                                                ActualizarRecepcionPallet(
                                                                    item.id,
                                                                    checked,
                                                                );
                                                            }}
                                                        />
                                                    )}
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <NumeroPallet
                                                        pallet={item}
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    {item.evs_numero}
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.total_pacas ||
                                                            0
                                                        }
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.pacas_turno_actual ||
                                                            0
                                                        }
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.pacas_turno_anterior ||
                                                            0
                                                        }
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <RenderNumber
                                                        value={
                                                            item.total_pacas_reclasificacion ||
                                                            0
                                                        }
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <Badge
                                                        text={
                                                            item.es_conforme
                                                                ? "Sí"
                                                                : "No"
                                                        }
                                                        variant={
                                                            item.es_conforme
                                                                ? "success"
                                                                : "danger"
                                                        }
                                                    />
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <NullableValue
                                                        value={
                                                            item.tarjeta_salida
                                                        }
                                                    >
                                                        <Badge
                                                            text={
                                                                item.tarjeta_salida
                                                            }
                                                            variant={"danger"}
                                                        />
                                                    </NullableValue>
                                                </td>

                                                <td className="text-center text-nowrap">
                                                    <RenderKilogramo
                                                        value={item.total_peso}
                                                        decimalScale={2}
                                                    />
                                                </td>
                                            </tr>
                                        );
                                    })}
                                </React.Fragment>
                            );
                        })}
                    </tbody>
                </table>
            </div>
        </React.Fragment>
    );
};
